export default __webpack_public_path__ + "static/media/invoicesEmpty.2c08e17f.svg";